import { render, staticRenderFns } from "./StorefinderAccordion.vue?vue&type=template&id=65262aee"
import script from "./StorefinderAccordion.vue?vue&type=script&lang=js"
export * from "./StorefinderAccordion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65262aee')) {
      api.createRecord('65262aee', component.options)
    } else {
      api.reload('65262aee', component.options)
    }
    module.hot.accept("./StorefinderAccordion.vue?vue&type=template&id=65262aee", function () {
      api.rerender('65262aee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/storefinder/Resources/Private/Assets/Scripts/Components/StorefinderAccordion.vue"
export default component.exports